<template>
  <div class="w-full max-h-screen bg-background flex flex-col relative">
    <PageHeader title="Internal"/>
    <main
        class="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6"
    >
      <!-- Staff Management -->
      <is-authorized
          :roles="['user']"
          :permissions="[
          'manage:staff',
          'create:staff',
          'read:staff',
          'update:staff',
          'delete:staff',
        ]"
      >
        <router-link
            to="/internal/staff"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="h-10 w-10 mr-5 stroke-current"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path d="M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0" />
            <path d="M12 10m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" />
            <path d="M6.168 18.849a4 4 0 0 1 3.832 -2.849h4a4 4 0 0 1 3.834 2.855" />
          </svg>

          <h2 class="text-lg uppercase">Staff Management</h2>
        </router-link>
      </is-authorized>


      <!-- Guest -->
      <router-link
          to="/internal/guest"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="h-10 w-10 mr-5 stroke-current"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path d="M12 13a3 3 0 1 0 0-6 3 3 0 0 0 0 6M6.201 18.744A4 4 0 0 1 10 16h4a4 4 0 0 1 3.798 2.741"/><path d="M19.875 6.27c.7.398 1.13 1.143 1.125 1.948v7.284c0 .809-.443 1.555-1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1-2.184 0l-6.75-4.27A2.225 2.225 0 0 1 3 15.502V8.217c0-.809.443-1.554 1.158-1.947l6.75-3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98z"/>
        </svg>

        <h2 class="text-lg uppercase">Guest</h2>
      </router-link>


      <!-- Attendance -->
      <router-link
          to="/internal/attendance"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="h-10 w-10 mr-5 stroke-current"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z"/><path d="M10.5 21H6a2 2 0 0 1-2-2V7a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v3M16 3v4M8 3v4M4 11h10"/><path d="M14 18a4 4 0 1 0 8 0 4 4 0 1 0-8 0"/><path d="M18 16.5V18l.5.5"/>
        </svg>

        <h2 class="text-lg uppercase">Attendance</h2>
      </router-link>



      <!-- Holiday Planner -->
      <is-authorized
          :roles="['user']"
          :permissions="['manage:leaveOwn', 'manage:leaveAll']"
      >
        <router-link
            to="/internal/holiday"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 19l9 2-9-18-9 18 9-2zm0 0v-8"
            />
          </svg>

          <h2 class="text-lg uppercase">Holiday Planner</h2>
        </router-link>
      </is-authorized>

      <!-- Health and Safety -->
      <is-authorized :roles="['user']" :permissions="['manage:internal']">
        <router-link
            to="/internal/healthnsafety"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
            />
          </svg>

          <h2 class="text-lg uppercase">Health and Safety</h2>
        </router-link>
      </is-authorized>
      <!-- Fleet Management -->
      <is-authorized
          :roles="['user']"
          :permissions="[
          'manage:fleets',
          'create:fleets',
          'read:fleets',
          'update:fleets',
          'delete:fleets',
        ]"
      >
        <router-link
            to="/internal/fleets"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path
                d="M9 17a2 2 0 11-4 0 2 2 0 014 0zM19 17a2 2 0 11-4 0 2 2 0 014 0z"
            />
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M13 16V6a1 1 0 00-1-1H4a1 1 0 00-1 1v10a1 1 0 001 1h1m8-1a1 1 0 01-1 1H9m4-1V8a1 1 0 011-1h2.586a1 1 0 01.707.293l3.414 3.414a1 1 0 01.293.707V16a1 1 0 01-1 1h-1m-6-1a1 1 0 001 1h1M5 17a2 2 0 104 0m-4 0a2 2 0 114 0m6 0a2 2 0 104 0m-4 0a2 2 0 114 0"
            />
          </svg>
          <h2 class="text-lg uppercase">Fleet Management</h2>
        </router-link>
      </is-authorized>
      <!-- Internal Certification -->
      <is-authorized :roles="['user']" :permissions="['manage:internal_docs']">
        <router-link
            to="/internal/documents"
            class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
        >
          <svg
              class="stroke-current h-10 w-10 mr-5"
              fill="none"
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="1.5"
              viewBox="0 0 24 24"
          >
            <path d="M12 14l9-5-9-5-9 5 9 5z"/>
            <path
                d="M12 14l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14z"
            />
            <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="1.5"
                d="M12 14l9-5-9-5-9 5 9 5zm0 0l6.16-3.422a12.083 12.083 0 01.665 6.479A11.952 11.952 0 0012 20.055a11.952 11.952 0 00-6.824-2.998 12.078 12.078 0 01.665-6.479L12 14zm-4 6v-7.5l4-2.222"
            />
          </svg>

          <h2 class="text-lg uppercase">Internal Docs</h2>
        </router-link>
      </is-authorized>


      <router-link
          to="/internal/goods-in"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path
              d="m12 21-8-4.5v-9l8-4.5 8 4.5v4.5M12 12l8-4.5M12 12v9M12 12l-8-4.5M22 18h-7M18 15l-3 3 3 3"
          />
        </svg>

        <h2 class="text-lg uppercase">Goods In</h2>
      </router-link>
      <router-link
          to="/internal/loan-equipment"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path d="M20.866 10.45a9 9 0 1 0-7.815 10.488"/>
          <path d="M12 7v5l1.5 1.5M21 15h-2.5a1.5 1.5 0 0 0 0 3h1a1.5 1.5 0 0 1 0 3H17M19 21v1m0-8v1"/>


        </svg>
        <h2 class="text-lg uppercase">Loan Equipment</h2>
      </router-link>
      <router-link
          to="/internal/service"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path
              d="M5 7a4 4 0 1 0 8 0 4 4 0 1 0-8 0M3 21v-2a4 4 0 0 1 4-4h4a4 4 0 0 1 4 4v2M16 3.13a4 4 0 0 1 0 7.75M21 21v-2a4 4 0 0 0-3-3.85"/>


        </svg>
        <h2 class="text-lg uppercase">Engineers</h2>
      </router-link>

      <router-link
          to="/internal/repair"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 80 80"
        >
          <path
              d="M26 65c6.065 0 11-4.935 11-11s-4.935-11-11-11-11 4.935-11 11 4.935 11 11 11zm0-20c4.962 0 9 4.038 9 9s-4.038 9-9 9-9-4.038-9-9 4.038-9 9-9z"/>
          <path
              d="m5.876 57.992 4.812.602a15.988 15.988 0 0 0 1.237 2.985l-2.978 3.828a1 1 0 0 0 .082 1.321l4.243 4.243a1 1 0 0 0 1.32.082l3.83-2.978c.949.512 1.949.926 2.984 1.237l.602 4.812A1 1 0 0 0 23 75h6a1 1 0 0 0 .992-.876l.602-4.812a15.942 15.942 0 0 0 2.985-1.237l3.828 2.978a1 1 0 0 0 1.321-.082l4.243-4.243a1 1 0 0 0 .082-1.32l-2.978-3.83c.512-.949.926-1.949 1.237-2.984l4.812-.602A1 1 0 0 0 47 57v-6a1 1 0 0 0-.876-.992l-4.812-.602a15.942 15.942 0 0 0-1.237-2.985l2.978-3.828a1 1 0 0 0-.082-1.321l-4.243-4.243a1 1 0 0 0-1.32-.082l-3.83 2.978a15.951 15.951 0 0 0-2.984-1.237l-.602-4.812A1 1 0 0 0 29 33h-6a1 1 0 0 0-.992.876l-.602 4.812a15.988 15.988 0 0 0-2.985 1.237l-3.828-2.978a1 1 0 0 0-1.321.082l-4.243 4.243a1 1 0 0 0-.082 1.32l2.978 3.83a15.951 15.951 0 0 0-1.237 2.984l-4.812.602A1 1 0 0 0 5 51v6a1 1 0 0 0 .876.992zM7 51.882l4.599-.574a1 1 0 0 0 .845-.747c.331-1.309.85-2.559 1.539-3.715a1 1 0 0 0-.07-1.126l-2.845-3.658 2.994-2.994 3.658 2.845a1 1 0 0 0 1.126.07 13.916 13.916 0 0 1 3.715-1.54 1 1 0 0 0 .747-.844L23.883 35h4.234l.575 4.599a1 1 0 0 0 .747.845c1.309.331 2.559.85 3.715 1.539a1 1 0 0 0 1.126-.07l3.658-2.845 2.994 2.994-2.845 3.658a1 1 0 0 0-.07 1.126 13.916 13.916 0 0 1 1.54 3.715 1 1 0 0 0 .844.747l4.599.575v4.234l-4.599.575a1 1 0 0 0-.845.747 13.918 13.918 0 0 1-1.539 3.715 1 1 0 0 0 .07 1.126l2.845 3.658-2.994 2.994-3.658-2.845a.997.997 0 0 0-1.126-.07 13.916 13.916 0 0 1-3.715 1.54 1 1 0 0 0-.747.844L28.117 73h-4.234l-.575-4.599a1 1 0 0 0-.747-.845 13.918 13.918 0 0 1-3.715-1.539.997.997 0 0 0-1.126.07l-3.658 2.845-2.994-2.994 2.845-3.658a1 1 0 0 0 .07-1.126 13.916 13.916 0 0 1-1.54-3.715 1 1 0 0 0-.844-.747L7 56.117v-4.234zM68.572 5.18A1 1 0 0 0 67 6v11.787l-7 2.625-7-2.625V6a1 1 0 0 0-1.572-.82A15.018 15.018 0 0 0 45 17.48c0 5.13 2.667 9.935 7 12.675V67c0 4.411 3.589 8 8 8s8-3.589 8-8V30.155c4.333-2.74 7-7.544 7-12.675 0-4.892-2.403-9.49-6.428-12.3zM66.5 28.727a1 1 0 0 0-.499.865V67c0 3.309-2.691 6-6 6s-6-2.691-6-6V29.592a1 1 0 0 0-.499-.865C49.491 26.403 47 22.094 47 17.48a13.01 13.01 0 0 1 4-9.37v10.37a1 1 0 0 0 .649.937l8 3a.999.999 0 0 0 .702 0l8-3A1 1 0 0 0 69 18.48V8.11a13.01 13.01 0 0 1 4 9.37c0 4.614-2.491 8.923-6.501 11.247z"/>
        </svg>
        <h2 class="text-lg uppercase">SERVICE & REPAIR</h2>
      </router-link>

      <router-link
          to="/internal/purchase"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"

        >
          <path stroke="none" d="M0 0h24v24H0z"/>
          <path d="M4 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0M15 19a2 2 0 1 0 4 0 2 2 0 1 0-4 0"/>
          <path d="M17 17H6V3H4"/>
          <path d="m6 5 14 1-1 7H6"/>
        </svg>
        <h2 class="text-lg uppercase">Purchasing</h2>
      </router-link>


      <router-link
          to="/internal/sales"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"

        >
          <path stroke="none" d="M0 0h24v24H0z"/><path d="M3 13a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1zM9 9a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM15 5a1 1 0 0 1 1-1h4a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1h-4a1 1 0 0 1-1-1zM4 20h14"/>
        </svg>
        <h2 class="text-lg uppercase">Sales Orders & Despatch</h2>
      </router-link>

      <router-link
          to="/internal/invoice"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"

        >

          <path d="M14 3v4a1 1 0 0 0 1 1h4" />
          <path d="M19 12v7a1.78 1.78 0 0 1 -3.1 1.4a1.65 1.65 0 0 0 -2.6 0a1.65 1.65 0 0 1 -2.6 0a1.65 1.65 0 0 0 -2.6 0a1.78 1.78 0 0 1 -3.1 -1.4v-14a2 2 0 0 1 2 -2h7l5 5v4.25" />


        </svg>
        <h2 class="text-lg uppercase">Invoices & Credits List</h2>
      </router-link>


      <router-link
          to="/internal/returns"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"
        >
          <path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
          <path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0" />
          <path d="M5 17h-2v-11a1 1 0 0 1 1 -1h9v6h-5l2 2m0 -4l-2 2" />
          <path d="M9 17l6 0" />
          <path d="M13 6h5l3 5v6h-2" />
        </svg>
        <h2 class="text-lg uppercase">Returns</h2>
      </router-link>

      <router-link
          to="/internal/codes"
          class="group bg-white hover:bg-primary-highlight transition ease-in-out duration-100 rounded shadow-md text-secondary p-5 flex items-center relative"
      >
        <svg
            class="stroke-current h-10 w-10 mr-5"
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            viewBox="0 0 24 24"
            fill="none"
        >
          <path d="M12.5 16h-8.5a1 1 0 0 1 -1 -1v-10a1 1 0 0 1 1 -1h16a1 1 0 0 1 1 1v8" />
          <path d="M7 20h4" />
          <path d="M9 16v4" />
          <path d="M20 21l2 -2l-2 -2" />
          <path d="M17 17l-2 2l2 2" />
        </svg>
        <h2 class="text-lg uppercase">Agent Return Codes</h2>
      </router-link>


    </main>
  </div>
</template>

<script>
const PageHeader = () => import("@/components/PageHeader.vue");
const IsAuthorized = () => import("@/components/Auth/IsAuthorized.vue");

export default {
  name: "HR",
  components: {
    PageHeader,
    IsAuthorized,
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
